import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
export default class SortDropdown extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "open", false);
  }
  view() {
    const {
      options,
      currentKey,
      onChange
    } = this.attrs;
    const current = options.find(o => o.key === currentKey) || options[0];
    const label = typeof current?.label === 'function' ? current.label() : current?.label ?? currentKey;
    return m("div", {
      className: "AvocadoDiscussions-sortWrap"
    }, m("button", {
      className: `AvocadoDiscussions-sortTrigger${this.open ? ' is-open' : ''}`,
      onclick: () => {
        this.open = !this.open;
        m.redraw();
      }
    }, label, m("i", {
      className: `fas fa-chevron-${this.open ? 'up' : 'down'}`,
      "aria-hidden": "true"
    })), this.open && m("div", {
      className: "AvocadoDiscussions-sortDropdown"
    }, options.map(option => {
      const optLabel = typeof option.label === 'function' ? option.label() : option.label;
      return m("button", {
        key: option.key,
        className: `AvocadoDiscussions-sortOption${currentKey === option.key ? ' is-active' : ''}`,
        onclick: () => {
          this.open = false;
          onChange(option.key);
        }
      }, m("span", {
        className: "AvocadoDiscussions-sortOption-check"
      }, currentKey === option.key && m("i", {
        className: "fas fa-check",
        "aria-hidden": "true"
      })), optLabel);
    })));
  }
}
flarum.reg.add('ramon-avocado', 'forum/components/shared/SortDropdown', SortDropdown);